import grapesjs from 'drapcode-builder';
import loadTraits from './traits';
export default grapesjs.plugins.add('webconnect-event-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'webconnect-event',
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
